import React from 'react';
import { motion } from 'framer-motion';

export const SectionTitle = ({ 
  title, 
  subtitle, 
  description, 
  centered = true,
  className = '' 
}) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.5 }}
      className={`${centered ? 'text-center' : ''} ${className}`}
    >
      {subtitle && (
        <span className="inline-block px-4 py-1.5 bg-secondary/10 text-secondary rounded-full text-sm font-semibold mb-4">
          {subtitle}
        </span>
      )}
      <h2 className="text-3xl sm:text-4xl lg:text-4xl font-heading font-bold text-foreground mb-4">
        {title}
      </h2>
      {description && (
        <p className="text-base sm:text-lg text-muted-foreground max-w-3xl mx-auto leading-relaxed">
          {description}
        </p>
      )}
    </motion.div>
  );
};
